'use client';
import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { ProjectSettings } from 'shared/types/projectSettings/ProjectSettings';
import { getCookie } from 'typescript-cookie';
import CustomerCartDetails from '@/components/customercenter-ui/components/customer-detail/components/Cart/CartDetails';
import CustomerCreditSummary from '@/components/customercenter-ui/components/customer-detail/components/CreditSummary/creditSummary';
import BackButton from '@/components/customercenter-ui/components/ui/back-button';
import MailCancelSvg from '@/components/customercenter-ui/svgs/mailCancel';
import { useProjSettings } from '@/frontastic/hooks/useProjectSettings/useProjectSettings';
import { GlobalPageTexts } from '@/helpers/i18n';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import { getPageUrl, PathNames, TranslateText } from '@/helpers/utils/siteUtils';
import PowerReviews from './powerReviews';
import ProductDetailsDesktop from './productDetailsDesktp';
import { DEFAULT_SITE_LANG, COOKIE_KEYS } from '../../../../../../../constants/constant';
import Loader from '../../../../ui/loader';
import { ProductContext } from '../../contexts';

const ProductDetails = () => {
  const Texts = TranslateText(GlobalPageTexts, DEFAULT_SITE_LANG);
  const { productData, product } = useContext(ProductContext);
  const [backUrl, setBackUrl] = useState('');
  const { isMailOrderProduct } = useContext(ProductContext);
  const params = useSearchParams();
  const fromOrderDetails = params.get('fromOrder') ?? false;
  const projectSettings: ProjectSettings = useProjSettings();
  const allowedCreditSites = JSON.parse(projectSettings?.allowedCreditSites ?? 'ZBSite');
  const [siteId, setSiteId] = useState<string>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [isError, setIsError] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [seeSimilarItems, setSeeSimilarItems] = useState<boolean | undefined>(undefined);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [notificationMessage, setNotificationMessage] = useState('');

  useEffect(() => {
    const cookieSiteId = getCookie(COOKIE_KEYS.selectedSite) ?? 'ZBSite';
    setSiteId(cookieSiteId);
  }, []);

  useEffect(() => {
    if (fromOrderDetails) {
      const backUrlPath = getPageUrl(PathNames.ORDER_DETAILS) ?? '';
      const url = new URL(`${window.location.origin}${backUrlPath}`);
      const params = url?.searchParams;
      const fromCustomerSearch = params?.get('fromCustomerSearch') === 'true';
      if (!fromCustomerSearch) {
        url.searchParams.set('fromOrder', 'true');
      }
      setBackUrl(url.toString());
    } else {
      const backurl = getPageUrl(PathNames.SEARCH);
      const url = new URL(`${window.location.origin}${backurl}`);
      url.searchParams.set('backUrl', 'true');
      setBackUrl(url.toString());
    }
  }, [fromOrderDetails]);

  return (
    <>
      {productData && product ? (
        <>
          <section className="mx-auto max-w-[1390px]">
            {isMailOrderProduct && (
              <section className="my-4 flex items-center rounded-sm border-2 border-scarletRed bg-[#FFEBEB] px-3 py-2 text-16 font-bold text-scarletRed">
                <MailCancelSvg />
                <p className="ml-1">{mapLocaleToMeaningfulFormat().mailOrderErrorDiscription}</p>
              </section>
            )}

            <div className="flex justify-between gap-10">
              <section className="my-4 w-[1024px]">
                <ProductDetailsDesktop
                  setNotificationMessage={setNotificationMessage}
                  setIsError={setIsError}
                  setSeeSimilarItems={setSeeSimilarItems}
                />
              </section>
              <aside className="my-4 w-[335px]">
                <div className="mb-5 flex justify-end">
                  <BackButton
                    text={fromOrderDetails ? Texts.backToOrderDetails : Texts.backToSearchResults}
                    className="flex text-blueLight underline"
                    url={backUrl}
                  />
                </div>
                <div className="mb-5 flex flex-col gap-5">
                  <CustomerCartDetails />
                  {allowedCreditSites?.creditSites?.includes(siteId) && <CustomerCreditSummary />}
                </div>
              </aside>
            </div>
          </section>

          {!isMailOrderProduct && (
            <section className="max-w-screen-9xl relative mx-auto mt-20 md:px-[40px]">
              <PowerReviews />
            </section>
          )}
        </>
      ) : (
        <section className="min-h-[1000px]">
          <Loader />
        </section>
      )}
    </>
  );
};
export default ProductDetails;
